import { Component, OnInit, ViewChild, ElementRef, inject, model, signal, computed } from '@angular/core';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { BookService } from 'src/app/services/book.service';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Observable, startWith, map, debounceTime } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'kbm-author-chips',
  templateUrl: './author-chips.component.html',
  styleUrls: ['./author-chips.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatOptionModule,
    ReactiveFormsModule,
    AsyncPipe,
  ]
})
export class AuthorChipsComponent implements OnInit {
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  @ViewChild('authorInput') authorInput!: ElementRef<HTMLInputElement>;

  authors = model.required<string[]>();

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  separatorKeysCodes = [
    ENTER
  ];

  authorCtrl = new UntypedFormControl();

  allAuthors: string[] = [];

  filteredNames!: Observable<string[]>;

  bookService = inject(BookService);

  ngOnInit(): void {
    this.loadAuthors();
    this.filteredNames = this.authorCtrl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        map((value: any) => this._filter(value || '')),
      );

  }

  async loadAuthors() {
    try {
      const authorsList = await this.bookService.getAuthorList();
      this.allAuthors = authorsList.map(a => a.author);
    }
    catch (err) {
      console.error(err);
    }
  }

  addEvt(evt: MatChipInputEvent): void {
    const value = (evt.value || '').trim();
    // Add our Author
    if (value) {
      this.authors().push(value);

      // console.log('Adding author', JSON.stringify(this.authors()));

    };

    // Clear input value
    evt.chipInput!.clear();
    this.authorInput.nativeElement.value = '';
    this.authorCtrl.setValue(null);

  }

  removeEvt(author: string): void {
    const index = this.authors().indexOf(author);

    if (index >= 0) {
      this.authors().splice(index, 1);
    }
  }

  selectedEvt(event: MatAutocompleteSelectedEvent): void {
    if (this.authors) {
      this.authors().push(event.option.viewValue);
    } else {
      console.log('Huh, no authors to start');
    }
    this.authorInput.nativeElement.value = '';
    this.authorCtrl.setValue(null);
    // console.log('Selected author', JSON.stringify(this.authors()));

  }


  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();
    return this.allAuthors.filter(
      (entry) => entry.toLowerCase().includes(filterValue)
    );
  }
}
